import gql from 'graphql-tag';

import conversationFragment from '../fragments/conversationFragment';

export const mutationUpdateConversation = gql`
  mutation updateConversation(
    $id: DokkioID!
    $name: String
    $dokkioTagIDs: [DokkioID!]
  ) {
    updateConversation(
      id: $id
      name: $name
      dokkioTagIDs: $dokkioTagIDs
    ) {
      ...conversationFragment
    }
  }
  ${conversationFragment}
`;
export default mutationUpdateConversation;
